module.exports = __webpack_public_path__ + "img/93973.7f464a3f.svg";